import axios from 'axios'
export default axios.create({
  // eslint-disable-next-line no-undef
  baseURL: process.env.REACT_APP_BFF,
  headers: {
    'Allow-control-allow-origin': '*',
  },
})
